export default "__VITE_ASSET__cd55b3e1__"